<template lang="pug">
  router-view
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import '@/assets/css/main-admin.sass'

@Component({
  components: {

  }
})
export default class WithNavLayout extends Vue {
  mounted () {
    // styles.use()
  }

  destroyed () {
    // styles.unuse()
  }
}
</script>

<style scoped lang="scss">

</style>
